import { render, staticRenderFns } from "./canvas-menu.vue?vue&type=template&id=1dc1ebc2&scoped=true&"
import script from "./canvas-menu.vue?vue&type=script&lang=js&"
export * from "./canvas-menu.vue?vue&type=script&lang=js&"
import style0 from "./canvas-menu.vue?vue&type=style&index=0&id=1dc1ebc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1ebc2",
  null
  
)

export default component.exports